import utils from '../../utils/util';
import config from '../../config';
import store from '../../store/index';
import { getSmsGuid, getSmsCode } from './sms.code';
function getPvareaid() {
  try {
    var _pvareaid = utils.getUrlParam('pvareaid');
    var _frompvareaid = utils.getUrlParam('frompvareaid');

    if (_frompvareaid) {
      return _frompvareaid;
    } else {
      return _pvareaid;
    }
  } catch (ex) {
    console.log(ex);
  }
  return '';
}
var _getFormData = function () {
  const salerElement = document.querySelector('#vr-salerId');
  const salerId = (salerElement && Number(salerElement.value)) || 0;
  const channelIdElement = document.querySelector('#vr-channelId');
  const channelId = (channelIdElement && channelIdElement.value) || '';
  let channelType = 0;
  if (channelId) {
    channelType = 1;
  }
  const d = {
    phone: String.prototype.trim.call(
      document.querySelector('#txtMobilePhone').value || '',
    ),
    userPhone: String.prototype.trim.call(
      document.querySelector('#txtMobilePhone').value || '',
    ),
    userName:
      String.prototype.trim.call(
        document.querySelector('#txtUserName').value || '',
      ) || '汽车之家用户',
    seriesId: parseInt(
      document
        .querySelector("[name='carChoose']")
        .getAttribute('selectedseriesid'),
    ),
    smsInfo: {
      smsGuid: getSmsGuid(),
      smsCode: getSmsCode(),
    },
    orderSource: 1,
    orderTarget: 1,
    dealerId: store.state.baseInfo.dealerId,
    dealerList: [
      {
        dealerId: store.state.baseInfo.dealerId,
        // 如果没有填空字符串和0
        promotionId:
          (document.querySelector("[name='redPacketInfo']") &&
            document
              .querySelector("[name='redPacketInfo']")
              .getAttribute('activityId')) ||
          '',
        redPacketType: parseInt(
          (document.querySelector("[name='redPacketInfo']") &&
            document
              .querySelector("[name='redPacketInfo']")
              .getAttribute('couponType')) ||
            0,
        ),
      },
    ],
    userId: store.state.user.loginInfo.user.userId,
    referrer: encodeURIComponent(document.referrer),
    currentUrl: encodeURIComponent(document.URL),
    sessionId: utils.getCookie('sessionid') || '',
    siteId: 313,
    productId: 1600,
    pvAreaId: getPvareaid(),
    loadId: typeof window.pageLoadId !== 'undefined' ? window.pageLoadId : '',
    activityId: 0,
    eid: '2|1211004|72|102|203475|301135',
    pvSubCategory: config.pvTrackData.subcategory,
    deviceId: utils.getCookie('app_deviceid') || '-1',
    visitInfo: getVisitInfo(),
    orderType: 1,

    pvSite: window.pvTrack.site,
    esFrom: utils.getCookie('esinfo', ''),
    odFrom: utils.getUrlParam('enfrom'),
    pvCategory: window.pvTrack.category,
    cityId: store.state.baseInfo.cityId,
    salesId: salerId,
    checked: document.querySelector('#protestation').checked,
  };
  if (channelId) {
    d.extendedField = JSON.stringify({ channelId, channelType });
  }
  console.warn(d);
  return d;
};

function getVisitInfo(eid, pvareaid) {
  let visitInfo = '';
  eid = eid || 0;
  pvareaid = pvareaid || 0;
  if (window.ah_get_visite_info) {
    visitInfo = window.ah_get_visite_info();
  }
  return visitInfo + '||' + eid + '||' + pvareaid;
}
export { _getFormData, getPvareaid, getVisitInfo };
